import { type RefObject, useRef, useEffect } from "react";

export const useEventListenerEffect = <E>(
  eventName: string,
  handler: (e: E) => void,
  element?: RefObject<HTMLElement>,
) => {
  const savedHandler = useRef(handler);

  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(() => {
    const target: HTMLElement | Window = element?.current ?? window;
    const listener = (event: Event) => savedHandler.current(event as E);

    target.addEventListener(eventName, listener);

    return () => {
      target.removeEventListener(eventName, listener);
    };
  }, [eventName, element]);
};
